
import { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import Button from '../../../components/base/Button';
import { getcommunityLikeAdd, getcommunityLikeOut, getcommunityCommentAdd, getcommunityCommentList,getcommunityFocusAdd,getcommunityFocusOut } from '@/services/community';
import { message } from 'antd';
import { maskUsername } from '@/utils/common';
export default function CommunityDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [post, setPost] = useState<any>(null);
  const [comments, setComments] = useState<any[]>([]);
  const [newComment, setNewComment] = useState('');
  const [isLiked, setIsLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(0);
  const [commentCount, setCommentCount] = useState(0);
  const [showShareModal, setShowShareModal] = useState(false);
  const [loading, setLoading] = useState(true);
  // 推荐相关帖子和热门标签（可从location.state或API获取）
  const [relatedPosts, setRelatedPosts] = useState<any[]>([]);
  const [hotTags, setHotTags] = useState<string[]>([]);

    const [replyingTo, setReplyingTo] = useState<{ parentId: number; targetUsername?: string } | null>(null);
  const [replyContent, setReplyContent] = useState('');
  const [isFollowing, setIsFollowing] = useState(false);

  useEffect(() => {
    // 兼容路由state和window.history.state
    let foundPost = null;
    if (location.state && location.state.post) {
      foundPost = location.state.post;
    } else if (window.history.state && window.history.state.usr && window.history.state.usr.post) {
      foundPost = window.history.state.usr.post;
    }
    if (foundPost) {
      setPost(foundPost);
      setLikeCount(foundPost.like_number ?? foundPost.likes ?? 0);
      setIsLiked(foundPost.is_liked === 1);
      setIsFollowing(foundPost.is_fans === 1);
      setCommentCount(foundPost.comment_number ?? foundPost.comments ?? 0);
      // 推荐相关帖子（同分类，排除当前）
      if (Array.isArray(location.state?.posts)) {
        setRelatedPosts(location.state.posts.filter((p: any) => p.id !== foundPost.id && (p.category?.id === foundPost.category?.id || p.category === foundPost.category)));
      }
      // 热门标签（从所有posts收集tags）
      if (Array.isArray(location.state?.posts)) {
        const allTags = location.state.posts.flatMap((p: any) => typeof p.tags === 'string' ? p.tags.split(',') : Array.isArray(p.tags) ? p.tags : []);
        setHotTags(Array.from(new Set(allTags.filter(Boolean))).slice(0, 8));
      }
    }
    // 评论区用API获取
    if (id) {
      getcommunityCommentList({ id: String(id) }).then(res => {
        if (res && res.status === 1 && Array.isArray(res.data)) {
          setComments(res.data);
          setCommentCount(res.data.length);
        } else {
          setComments([]);
          setCommentCount(0);
        }
        setLoading(false);
      }).catch(() => {
        setComments([]);
        setCommentCount(0);
        setLoading(false);
      });
    }
  }, [id, location.state]);

  const handleLike = () => {
    if (!post) return;
    if (!isLiked) {
      getcommunityLikeAdd({ id: String(post.id) }).then(res => {
        if (res && res.status === 1) {
          setIsLiked(true);
          setLikeCount(prev => prev + 1);
        }
      });
    } else {
      getcommunityLikeOut({ id: String(post.id) }).then(res => {
        if (res && res.status === 1) {
          setIsLiked(false);
          setLikeCount(prev => Math.max(prev - 1, 0));
        }
      });
    }
  };

  //关注作者
  const handleFollow = () => {
    if (!post) return;
    const action = isFollowing ? getcommunityFocusOut : getcommunityFocusAdd;
    action({ id: String(post.id), user_id: String(post.user_id) }).then(res => {
      if (res && res.status === 1) {
        message.success(res.info || (isFollowing ? '已取消关注' : '关注成功'));
        setIsFollowing(!isFollowing);
      }else{
        message.error(res.info || (isFollowing ? '取消关注失败' : '关注失败'));
      }
    });
  };
  const handleShare = () => {
    setShowShareModal(true);
  };

  const handleShareToPlatform = (platform: string) => {
    const shareUrl = window.location.href;
    const shareTitle = post?.title || '';
    const shareContent = post?.content?.substring(0, 100) + '...' || '';
    
    switch (platform) {
      case 'wechat':
        navigator.clipboard.writeText(`${shareTitle}\n${shareContent}\n${shareUrl}`).then(() => {
          showShareSuccess('链接已复制到剪贴板，可在微信中粘贴分享');
        });
        break;
      case 'qq':
        const qqUrl = `https://connect.qq.com/widget/shareqq/index.html?url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(shareTitle)}&summary=${encodeURIComponent(shareContent)}`;
        window.open(qqUrl, '_blank');
        break;
      case 'weibo':
        const weiboUrl = `https://service.weibo.com/share/share.php?url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(shareTitle + ' ' + shareContent)}`;
        window.open(weiboUrl, '_blank');
        break;
      case 'link':
        navigator.clipboard.writeText(shareUrl).then(() => {
          showShareSuccess('链接已复制到剪贴板');
        });
        break;
    }
    setShowShareModal(false);
  };

  const showShareSuccess = (message: string) => {
    const successDiv = document.createElement('div');
    successDiv.className = 'fixed top-4 right-4 bg-green-500 text-white px-4 py-3 rounded-lg shadow-lg z-50 flex items-center';
    successDiv.innerHTML = `<i class="ri-check-line mr-2"></i>${message}`;
    document.body.appendChild(successDiv);
    
    setTimeout(() => {
      if (document.body.contains(successDiv)) {
        document.body.removeChild(successDiv);
      }
    }, 3000);
  };

  const handlePublishComment = () => {
    if (!newComment.trim() || !id) return;
    getcommunityCommentAdd({ id: String(id),pid:'', content: newComment }).then(res => {
      if (res && res.status === 1) {
        setNewComment('');
        getcommunityCommentList({ id: String(id) }).then(res2 => {
          if (res2 && res2.status === 1 && Array.isArray(res2.data?.lists)) {
            setComments(res2.data);
            setCommentCount(res2.data.length);
          }
        });
        // 显示成功提示
        const successDiv = document.createElement('div');
        successDiv.className = 'fixed top-4 right-4 bg-green-500 text-white px-4 py-3 rounded-lg shadow-lg z-50 flex items-center';
        successDiv.innerHTML = '<i class="ri-check-line mr-2"></i>'+res.info||'评论发布成功';
        document.body.appendChild(successDiv);
        setTimeout(() => {
          if (document.body.contains(successDiv)) {
            document.body.removeChild(successDiv);
          }
        }, 3000);
      }
    });
  };
  const handleReplyClick = (parentId: number, targetUsername?: string) => {
    
      setReplyingTo({ parentId, targetUsername });
      setReplyContent(''); // Clear content when opening
    
  };

  const handlePublishReply = () => {
    if (!replyContent.trim() || !replyingTo || !id) return;

    const finalContent = replyingTo.targetUsername ? `@${maskUsername(replyingTo.targetUsername)}: ${replyContent}` : replyContent;

    getcommunityCommentAdd({
      id: String(id),
      pid: String(replyingTo.parentId),
      content: finalContent,
    }).then(res => {
      if (res && res.status === 1) {
        setReplyingTo(null);
        setReplyContent('');
        message.success(res.info || '回复发布成功');
        // Re-fetch comments to show the new reply
        getcommunityCommentList({ id: String(id) }).then(res2 => {
          if (res2 && res2.status === 1 && Array.isArray(res2.data)) {
            setComments(res2.data);
          }
        });
      } else {
        // Optional: show an error message
        console.error('Failed to publish reply:', res?.msg);
      }
    }).catch(error => {
      console.error('Error publishing reply:', error);
    });
  };
  const handleCommentLike = (commentId: number, isReply: boolean = false, parentId?: number) => {
    if (isReply && parentId) {
      setComments(prev => prev.map(comment => {
        if (comment.id === parentId) {
          return {
            ...comment,
            replies: comment.replies.map((reply: any) => 
              reply.id === commentId 
                ? { ...reply, likes: reply.likes + 1 }
                : reply
            )
          };
        }
        return comment;
      }));
    } else {
      setComments(prev => prev.map(comment => 
        comment.id === commentId 
          ? { ...comment, likes: comment.likes + 1 }
          : comment
      ));
    }
  };

  const formatTime = (dateString: string) => {
    if (typeof dateString === 'string' && (dateString.includes('分钟前') || dateString.includes('小时前') || dateString.includes('刚刚'))) {
      return dateString;
    }
    // 兼容数字时间戳
    let date: Date;
    if (typeof dateString === 'number') {
      // 可能是时间戳，单位秒或毫秒
      date = new Date(dateString.toString().length === 10 ? dateString * 1000 : dateString);
    } else {
      date = new Date(dateString);
    }
    if (isNaN(date.getTime())) return '';
    const now = new Date();
    const diff = now.getTime() - date.getTime();
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const days = Math.floor(hours / 24);
    if (days > 0) return `${days}天前`;
    if (hours > 0) return `${hours}小时前`;
    return '刚刚';
  };

  const formatNumber = (num: number) => {
    if (num >= 1000) return `${(num / 1000).toFixed(1)}k`;
    return num.toString();
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Header />
        <div className="flex items-center justify-center min-h-[60vh]">
          <div className="text-center">
            <div className="w-8 h-8 border-4 border-green-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
            <p className="text-gray-600">加载中...</p>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  if (!post) {
    return (
      <div className="min-h-screen bg-gray-50">
        <Header />
        <div className="flex items-center justify-center min-h-[60vh]">
          <div className="text-center">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-file-text-line text-gray-400 text-2xl"></i>
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">帖子不存在</h3>
            <p className="text-gray-500 mb-4">该帖子可能已被删除或不存在</p>
            <Button onClick={() => navigate('/community')} className="whitespace-nowrap cursor-pointer">
              返回社区
            </Button>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="py-6">
        <div className="container mx-auto px-4 max-w-6xl">
          {/* 返回按钮 */}
          <div className="mb-6">
            <button
              onClick={() => navigate('/community')}
              className="flex items-center text-gray-600 hover:text-gray-800 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-line mr-2"></i>
              返回社区
            </button>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
            {/* 主内容区 - 80%宽度 */}
            <div className="lg:col-span-4">
              {/* 帖子详情 */}
              <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
                {/* 作者信息 */}
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                      <span className="text-white font-medium text-lg">
                        {(post.username ?? post.author ?? '').charAt(0)}
                      </span>
                    </div>
                    <div>
                      <div className="flex items-center space-x-2">
                        <h4 className="font-medium text-gray-900">{maskUsername(post.username) ?? post.author ?? ''}</h4>
                        {/* 认证标识可根据API字段调整 */}
                        {post.isVerified && (
                          <i className="ri-verified-badge-fill text-blue-500"></i>
                        )}
                        <span className={`px-2 py-1 rounded-full text-xs ${
                          (typeof post.category === 'object' ? post.category.name : post.category) === '足球' ? 'bg-green-100 text-green-700' :
                          (typeof post.category === 'object' ? post.category.name : post.category) === '篮球' ? 'bg-orange-100 text-orange-700' :
                          (typeof post.category === 'object' ? post.category.name : post.category) === '网球' ? 'bg-yellow-100 text-yellow-700' :
                          (typeof post.category === 'object' ? post.category.name : post.category) === '游泳' ? 'bg-blue-100 text-blue-700' :
                          (typeof post.category === 'object' ? post.category.name : post.category) === '健身' ? 'bg-purple-100 text-purple-700' :
                          'bg-gray-100 text-gray-700'
                        }`}>
                          {typeof post.category === 'object' ? post.category.name : post.category}
                        </span>
                      </div>
                      <p className="text-sm text-gray-500">{formatTime(post.add_time ?? post.createdAt ?? '')}</p>
                    </div>
                  </div>
                  <button className="text-gray-400 hover:text-gray-600 cursor-pointer">
                    <i className="ri-more-line text-lg"></i>
                  </button>
                </div>
                {/* 帖子标题 */}
                <h1 className="text-xl font-bold text-gray-900 mb-4">{post.title}</h1>
                {/* 帖子内容 */}
                <div className="prose max-w-none mb-6">
                  <p className="text-gray-700 text-sm leading-relaxed whitespace-pre-line">{post.content}</p>
                </div>
                {/* 帖子图片（API图片字段兼容） */}
                {Array.isArray(post.images) && post.images.length > 0 && (
                  <div className="mb-6">
                    {post.images.length === 1 ? (
                      <img src={post.images[0]} alt="帖子图片" className="w-full max-w-2xl rounded-lg border" />
                    ) : post.images.length === 2 ? (
                      <div className="grid grid-cols-2 gap-3">
                        {post.images.map((image: string, index: number) => (
                          <img key={index} src={image} alt={`帖子图片${index + 1}`} className="w-full h-64 object-cover rounded-lg border" />
                        ))}
                      </div>
                    ) : (
                      <div className="grid grid-cols-2 gap-3">
                        {post.images.slice(0, 4).map((image: string, index: number) => (
                          <div key={index} className="relative">
                            <img src={image} alt={`帖子图片${index + 1}`} className="w-full h-32 object-cover rounded-lg border" />
                            {index === 3 && post.images.length > 4 && (
                              <div className="absolute inset-0 bg-black/50 rounded-lg flex items-center justify-center">
                                <span className="text-white font-medium">+{post.images.length - 4}</span>
                              </div>
                            )}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
                {/* 标签（兼容API字符串/数组） */}
                {post.tags && (
                  <div className="mb-6">
                    <div className="flex flex-wrap gap-2">
                      {(typeof post.tags === 'string' ? post.tags.split(',') : Array.isArray(post.tags) ? post.tags : []).filter(Boolean).map((tag: string) => (
                        <span key={tag} className="text-sm text-blue-600 hover:text-blue-800 cursor-pointer transition-colors">#{tag}</span>
                      ))}
                    </div>
                  </div>
                )}
                {/* 互动按钮 */}
                <div className="flex items-center justify-between pt-4 border-t">
                  <div className="flex items-center space-x-6">
                    <button onClick={handleLike} className={`flex items-center space-x-2 transition-all duration-200 cursor-pointer ${isLiked ? 'text-red-500' : 'text-gray-600 hover:text-red-500'}`}>
                      <i className={`text-lg ${isLiked ? 'ri-heart-fill' : 'ri-heart-line'}`}></i>
                      <span>{formatNumber(likeCount)}</span>
                    </button>
                    <div className="flex items-center space-x-2 text-gray-600">
                      <i className="ri-chat-3-line text-lg"></i>
                      <span>{formatNumber(commentCount)}</span>
                    </div>
                    <button onClick={handleShare} className="flex items-center space-x-2 text-gray-600 hover:text-green-500 cursor-pointer">
                      <i className="ri-share-line text-lg"></i>
                      <span>分享</span>
                    </button>
                  </div>
                  <button className="text-gray-400 hover:text-yellow-500 cursor-pointer">
                    <i className="ri-bookmark-line text-lg"></i>
                  </button>
                </div>
              </div>

              {/* 评论发布区 */}
              <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
                <h3 className="font-semibold text-gray-900 mb-4 flex items-center">
                  <i className="ri-chat-3-line text-blue-500 mr-2"></i>
                  发表评论
                </h3>
                <div className="flex space-x-4">
                  <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-medium">我</span>
                  </div>
                  <div className="flex-1">
                    <textarea
                      value={newComment}
                      onChange={(e) => setNewComment(e.target.value)}
                      placeholder="写下你的评论...分享你的观点和想法"
                      className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none resize-none text-sm"
                      rows={4}
                      maxLength={1000}
                    />
                    <div className="flex items-center justify-between mt-3">
                      <div className="flex items-center space-x-3 text-sm text-gray-500">
                        <button className="flex items-center hover:text-blue-500 cursor-pointer whitespace-nowrap">
                          <i className="ri-emotion-line mr-1"></i>
                          表情
                        </button>
                        <button className="flex items-center hover:text-green-500 cursor-pointer whitespace-nowrap">
                          <i className="ri-image-line mr-1"></i>
                          图片
                        </button>
                        <span className={`${newComment.length > 900 ? 'text-red-500' : ''}`}>
                          {newComment.length}/1000
                        </span>
                      </div>
                      <Button
                        onClick={handlePublishComment}
                        disabled={!newComment.trim()}
                        size="sm"
                        className="whitespace-nowrap cursor-pointer"
                      >
                        发布评论
                      </Button>
                    </div>
                  </div>
                </div>
              </div>

              {/* 评论列表 */}
              <div className="bg-white rounded-lg shadow-sm p-6">
                <h3 className="font-semibold text-gray-900 mb-6 flex items-center">
                  <i className="ri-message-line text-blue-500 mr-2"></i>
                  全部评论 ({commentCount})
                </h3>
                
                {comments.length > 0 ? (
                  <div className="space-y-6">
                    {comments.map((comment) => (
                      <div key={comment.id} className="space-y-4">
                        {/* 主评论 */}
                        <div className="flex space-x-4">
                          <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
                            <span className="text-white font-medium text-sm">
                              {(comment.username || '').charAt(0)}
                            </span>
                          </div>
                          <div className="flex-1 min-w-0">
                            <div className="flex items-center space-x-2 mb-2">
                              <h5 className="font-medium text-gray-900 text-sm">{maskUsername(comment.username)}</h5>
                              {comment.isVerified && (
                                <i className="ri-verified-badge-fill text-blue-500 text-sm"></i>
                              )}
                              <span className="text-sm text-gray-500">{formatTime(comment.add_time)}</span>
                            </div>
                            <p className="text-gray-700 mb-3 leading-relaxed text-sm">{comment.content}</p>
                            <div className="flex items-center space-x-4">
                              <button 
                                onClick={() => handleCommentLike(comment.id)}
                                className="flex items-center space-x-1 text-gray-600 hover:text-red-500 transition-colors cursor-pointer"
                              >
                                <i className="ri-heart-line text-sm"></i>
                                <span className="text-sm">{comment.likes}</span>
                              </button>
                              <button onClick={() => handleReplyClick(comment.id, comment.username)}  className="text-sm text-gray-600 hover:text-blue-500 transition-colors cursor-pointer whitespace-nowrap">
                                回复
                              </button>
                            </div>
                          </div>
                        </div>

                        {/* 回复评论 */}
                        {comment.child && comment.child.length > 0 && (
                          <div className="ml-14 space-y-4">
                            {comment.child.map((reply: any) => (
                              <div key={reply.id} className="flex space-x-3">
                                <div className="w-8 h-8 bg-purple-500 rounded-full flex items-center justify-center flex-shrink-0">
                                  <span className="text-white font-medium text-xs">
                                    {(reply.username || '').charAt(0)}
                                  </span>
                                </div>
                                <div className="flex-1 min-w-0">
                                  <div className="flex items-center space-x-2 mb-1">
                                    <h6 className="font-medium text-gray-900 text-sm">{maskUsername(reply.username)}</h6>
                                    {reply.isVerified && (
                                      <i className="ri-verified-badge-fill text-blue-500 text-xs"></i>
                                    )}
                                    <span className="text-xs text-gray-500">{formatTime(reply.add_time)}</span>
                                  </div>
                                  <p className="text-gray-700 text-sm mb-2 leading-relaxed">
                                    {reply.replyTo && (
                                      <span className="text-blue-600 mr-1">@{reply.replyTo}</span>
                                    )}
                                    {reply.content}
                                  </p>
                                  <div className="flex items-center space-x-3">
                                    <button 
                                      onClick={() => handleCommentLike(reply.id, true, comment.id)}
                                      className="flex items-center space-x-1 text-gray-600 hover:text-red-500 transition-colors cursor-pointer"
                                    >
                                      <i className="ri-heart-line text-xs"></i>
                                      <span className="text-xs">{reply.likes}</span>
                                    </button>
                                    <button onClick={() => handleReplyClick(reply.id, reply.username)} className="text-xs text-gray-600 hover:text-blue-500 transition-colors cursor-pointer whitespace-nowrap">
                                      回复
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                        {/* Reply Input Area */}
                        {replyingTo && replyingTo.parentId === comment.id && (
                          <div className="ml-14 mt-4">
                            <textarea
                              value={replyContent}
                              onChange={(e) => setReplyContent(e.target.value)}
                              placeholder={replyingTo.targetUsername ? `回复 @${replyingTo.targetUsername}` : '添加回复...'}
                              className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-1 focus:ring-green-500 focus:border-green-500 outline-none resize-none text-sm"
                              rows={3}
                              autoFocus
                            />
                            <div className="flex justify-end items-center mt-2 space-x-3">
                              <button onClick={() => setReplyingTo(null)} className="text-sm text-gray-600 hover:text-gray-900 px-3 py-1 rounded-md">取消</button>
                              <Button
                                onClick={handlePublishReply}
                                disabled={!replyContent.trim()}
                                size="sm"
                                className="whitespace-nowrap cursor-pointer"
                              >
                                发布
                              </Button>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-center py-12">
                    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <i className="ri-chat-3-line text-gray-400 text-2xl"></i>
                    </div>
                    <h3 className="text-lg font-medium text-gray-900 mb-2">暂无评论</h3>
                    <p className="text-gray-500">成为第一个发表评论的人吧！</p>
                  </div>
                )}
              </div>
            </div>

            {/* 侧边栏 - 调整为 20% 宽度 (lg:col-span-1) */}
            <div className="lg:col-span-1 space-y-6">
              {/* 作者信息卡片 */}
              <div className="bg-white rounded-lg shadow-sm p-6">
                <h3 className="font-semibold text-gray-900 mb-4">作者信息</h3>
                <div className="flex items-center space-x-3 mb-4">
                  <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center">
                    <span className="text-white font-medium text-xl">{(post.username ?? post.author ?? '').charAt(0)}</span>
                  </div>
                  <div>
                    <div className="flex items-center space-x-2">
                      <h4 className="font-medium text-gray-900">{maskUsername(post.username) ?? post.author ?? ''}</h4>
                      {post.isVerified && (<i className="ri-verified-badge-fill text-blue-500"></i>)}
                    </div>
                    <p className="text-sm text-gray-500">体育爱好者</p>
                  </div>
                </div>
                <div className="grid grid-cols-3 gap-4 text-center text-sm mb-4">
                  <div>
                    <div className="font-semibold text-gray-900">128</div>
                    <div className="text-gray-500">帖子</div>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900">2.3k</div>
                    <div className="text-gray-500">关注者</div>
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900">456</div>
                    <div className="text-gray-500">关注中</div>
                  </div>
                </div>
                <Button size="sm" onClick={handleFollow} className={`w-full whitespace-nowrap cursor-pointer ${
                    isFollowing
                      ? 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                      : 'bg-green-500 text-white hover:bg-green-600'
                  }`}>
                   {isFollowing ? '取消关注' : '关注作者'}
                </Button>
              </div>
              {/* 相关帖子（API数据） */}
              <div className="bg-white rounded-lg shadow-sm p-6">
                <h3 className="font-semibold text-gray-900 mb-4 flex items-center"><i className="ri-file-list-line text-blue-500 mr-2"></i>相关帖子</h3>
                <div className="space-y-4">
                  {relatedPosts.slice(0, 3).map((relatedPost) => (
                    <div key={relatedPost.id} className="group">
                      <h4 onClick={() => navigate(`/community/${relatedPost.id}`, { state: { post: relatedPost, posts: location.state?.posts } })} className="font-medium text-gray-900 group-hover:text-green-600 cursor-pointer text-sm line-clamp-2 mb-2">{relatedPost.title}</h4>
                      <div className="flex items-center text-xs text-gray-500 space-x-3">
                        <span>{formatTime(relatedPost.add_time ?? relatedPost.createdAt ?? '')}</span>
                        <span className="flex items-center"><i className="ri-heart-line mr-1"></i>{relatedPost.like_number ?? relatedPost.likes ?? 0}</span>
                        <span className="flex items-center"><i className="ri-chat-3-line mr-1"></i>{relatedPost.comment_number ?? relatedPost.comments ?? 0}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {/* 热门标签（API数据） */}
              <div className="bg-white rounded-lg shadow-sm p-6">
                <h3 className="font-semibold text-gray-900 mb-4 flex items-center"><i className="ri-hashtag text-orange-500 mr-2"></i>热门标签</h3>
                <div className="flex flex-wrap gap-2">
                  {hotTags.map((tag) => (
                    <span key={tag} className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-sm hover:bg-green-100 hover:text-green-700 cursor-pointer transition-colors">#{tag}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* 分享弹窗 */}
      {showShareModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full">
            <div className="flex items-center justify-between p-6 border-b">
              <h3 className="text-lg font-semibold text-gray-900">分享帖子</h3>
              <button
                onClick={() => setShowShareModal(false)}
                className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 cursor-pointer"
              >
                <i className="ri-close-line text-lg"></i>
              </button>
            </div>
            
            <div className="p-6">
              <div className="grid grid-cols-2 gap-4">
                <button
                  onClick={() => handleShareToPlatform('wechat')}
                  className="flex flex-col items-center p-4 rounded-lg hover:bg-gray-50 cursor-pointer"
                >
                  <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center mb-2">
                    <i className="ri-wechat-line text-white text-xl"></i>
                  </div>
                  <span className="text-sm font-medium">微信</span>
                </button>
                
                <button
                  onClick={() => handleShareToPlatform('qq')}
                  className="flex flex-col items-center p-4 rounded-lg hover:bg-gray-50 cursor-pointer"
                >
                  <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center mb-2">
                    <i className="ri-qq-line text-white text-xl"></i>
                  </div>
                  <span className="text-sm font-medium">QQ</span>
                </button>
                
                <button
                  onClick={() => handleShareToPlatform('weibo')}
                  className="flex flex-col items-center p-4 rounded-lg hover:bg-gray-50 cursor-pointer"
                >
                  <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mb-2">
                    <i className="ri-weibo-line text-white text-xl"></i>
                  </div>
                  <span className="text-sm font-medium">微博</span>
                </button>
                
                <button
                  onClick={() => handleShareToPlatform('link')}
                  className="flex flex-col items-center p-4 rounded-lg hover:bg-gray-50 cursor-pointer"
                >
                  <div className="w-12 h-12 bg-gray-500 rounded-full flex items-center justify-center mb-2">
                    <i className="ri-link text-white text-xl"></i>
                  </div>
                  <span className="text-sm font-medium">复制链接</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}